import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const WelcomeSection = styled.div`
  padding: ${rhythm(0)} ${rhythm(0.8)} ${rhythm(1.2)} ${rhythm(0.8)};
  // 2.08334vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;

export default WelcomeSection;
